import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, put, del } from '../api/client.js';

const KEY = (target, from, to) => ['schedule', target || 'me', from, to];

export function useSchedule({ target = 'me', from, to } = {}) {
  const qs = new URLSearchParams();
  qs.set('user', target);
  if (from) qs.set('from', String(from));
  if (to)   qs.set('to',   String(to));
  return useQuery({
    queryKey: KEY(target, from, to),
    queryFn: async () => (await get(`/api/schedule?${qs.toString()}`)).shifts || [],
    staleTime: 15_000,
  });
}

export function useCreateShift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => post('/api/schedule', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedule'] }),
  });
}

export function useUpdateShift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/schedule/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedule'] }),
  });
}

export function useCancelShift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => del(`/api/schedule/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schedule'] }),
  });
}
